import React, { use, useEffect, useRef, useState } from "react";
import axios from "axios";
import { set, useForm } from "react-hook-form";
import { useOutletContext, useNavigate } from "react-router-dom";
import $ from "jquery";
import { Client_View } from "../../utils/sweetalert";
import toastr from "../../utils/toast";
import Select from "react-select";

function AddClient({ onClose }) {
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [majorIndustries, setMajorIndustries] = useState([]);
  const [minorIndustries, setMinorIndustries] = useState([]);
  const [users, setUsers] = useState([]);
  const [companyinfos, setcompanyinfos] = useState([]);
  const [peVcReferred, setpeVcReferred] = useState([]);
  const [showOthergroupedCompany, setshowOthergroupedCompany] = useState(false);
  const groupedCompanyOption = watch("groupedCompanyOption");
  const [companyOptions, setCompanyOptions] = useState([]);
  const [pevcOptions, setPevcOptions] = useState([]);
  const [selectedPevc, setSelectedPevc] = useState(null);

  async function fetchAllDropdownData() {
    setGlobalLoading(false); //  Show loader before API call
    try {
      const res = await axios.get(`${API_BASE_URL}/clients/clientd`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = res.data;
      setData(data);
      setCompanies(data.companies || []);
      setCountries(data.countries || []);
      setMajorIndustries(data.majorIndustry || []);
      setUsers(data.users || []);
    } catch (error) {
      console.error("Error fetching form data:", error);
    }
  }

  // Fetch dropdown data once on mount
  useEffect(() => {
    fetchAllDropdownData();
  }, [token, API_BASE_URL]);

  const searchTimeout = useRef(null);
  const lastSelectedRef = useRef(null);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);

  async function get_companies_data(e) {
    try {
      setIsCompanyLoading(true);
      const res = await axios.post(
        `${API_BASE_URL}/clients/search_data`,
        {
          keywords: e,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      let options = [];

      const companies = res.data.companies;

      companies.forEach((company) => {
        options.push({
          id: company.id,
          name: company.name,
          tbl: company.tbl,
        });
      });

      // check exact match
      const exactMatch = options.some(
        (item) => item.name.toLowerCase() === e.toLowerCase(),
      );

      // add custom option if no exact match
      if (!exactMatch && e.trim() !== "") {
        options.unshift({
          id: e,
          name: e,
          tbl: "custom",
        });
      }

      setCompanyOptions(options);
    } catch (error) {
      setIsCompanyLoading(false);
      console.log(error);
      toastr.error(error.response.data.error);
    } finally {
      setIsCompanyLoading(false);
    }
  }

  const PEPV = () => {
    const $select2 = $('[name="companyinfo_id"]');

    $select2.select2({
      multiple: false,
      closeOnSelect: true,
      tags: true, // ✅ allow typed custom entries
      dropdownParent: $(".add_client"),
      createTag: function (params) {
        return {
          id: params.term,
          text: params.term,
          custom: true,
        };
      },
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/clients/companyInfoLoad`,
        dataType: "json",
        contentType: "application/json",
        delay: 250,
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          return JSON.stringify({ keywords: params.term });
        },
        processResults: function (data, params) {
          if (data.options && data.options.length > 0) {
            return {
              results: data.options.map((item, index) => ({
                id: item.value, // ✅ Add prefix to the ID
                value: item.value,
                text: item.label,
              })),
            };
          } else {
            return { results: [] }; // 👈 empty so that createTag is triggered
          }
        },
        cache: true,
      },
      placeholder: "Search PE/VC",
      allowClear: true,
      minimumInputLength: 2,
      language: function () {
        return "";
      },
      escapeMarkup: (markup) => markup,
    });

    $select2.on("select2:select", async (e) => {
      const selectedData = e.params.data;
      console.log(selectedData);
      if (selectedData.custom === true) {
        // Use the raw typed value for the form
        $select2.val(selectedData.id).trigger("change.select2"); // no append needed
        setValue("companyinfo_id", selectedData.text);
      } else {
        $select2.val(selectedData.id).trigger("change.select2"); // no append needed
        setValue("companyinfo_id", selectedData.id);
      }
    });

    $select2.on("select2:clear", function () {
      $select2.find("option").remove(); // remove all options
      $select2.val(null).trigger("change.select2");
      setValue("companyinfo_id", "");
    });

    return () => {
      $select2.off("change");
    };
  };

  const clearSelect = () => {
    setSelectedCompany(null);
    setValue("website", "");
    setValue("companies", ""); // clear react-hook-form value
    setcompanyinfos([]);
    setValue("industrymaster_id", "");
    setValue("industry_id", "");
    setValue("companyinfo_id", "");
  };

  const AlreadyExitClient = (id) => {
    Client_View({
      title: "",
      text: "This company is already a client",
      icon: "warning",
      confirmButtonText: "View Client",
      confirmCallback: () => ViewClient(id),
      cancleCallback: () => clearSelectedCompany(),
    });
  };

  const ViewClient = (id) => {
    onClose();
    setGlobalLoading(true);
    setTimeout(() => {
      navigate(`/client/view/${id}`);
    }, 1000);
  };

  const AlreadyExitCompanyInfo = async (id) => {
    // Client_View({
    //   title: "",
    //   text: "This company already exits",
    //   icon: "warning",
    //   confirmButtonText: "Want To Make It Client",
    //   confirmCallback: async () => ViewCompanyInfo(id),
    //   cancleCallback: async () => clearSelectedCompany(),
    // });
    ViewCompanyInfo(id);
  };

  const clearSelectedCompany = () => {
    clearSelect();
  };

  const ViewCompanyInfo = async (id) => {
    const $select = $('[name="companies"]');
    try {
      setGlobalLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/clients/getcompanyinfo/${id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const companyinfo = response.data.companyinfo;
      console.log("companyinfo", companyinfo);
      setValue("companies", id);
      setcompanyinfos(companyinfo);
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    console.log("companyinfos", companyinfos);
    if (!companyinfos) {
      return;
    }
    const website = companyinfos?.website || "";
    if (website.trim() === "") {
      setValue("website", "");
    } else if (
      !website.startsWith("http://") &&
      !website.startsWith("https://")
    ) {
      setValue("website", `http://${website}`);
    } else {
      setValue("website", companyinfos.website);
    }
    setValue("reference", data.new_reference);
    setValue("gcc", companyinfos.gcc);
    const initIndustries = async () => {
      const major = majorIndustries.find(
        (m) => m.id === companyinfos.industrymaster_id,
      );
      if (major) {
        setValue("industrymaster_id", major.id || "");
        await fetchMinorIndustry({ target: { value: major.id } });
      }
    };
    initIndustries();
  }, [companyinfos, majorIndustries]);

  useEffect(() => {
    const minor = minorIndustries.find(
      (m) => m.id === companyinfos.industry_id,
    );
    if (minor) {
      setValue("industry_id", minor.id || "");
    }
  }, [minorIndustries]);

  useEffect(() => {
    register("companyinfo_id", {
      required: peVcReferred === "yes" ? "required" : false,
    });
  }, [register, peVcReferred]);

  const onSubmit = async (data) => {
    // console.log(data);
    try {
      // setGlobalLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/clients/add_client`,
        { data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      onClose();
      toastr.success("Client Added Successfully");
      navigate("/client/view/" + response.data.companyid);
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error submitting form.");
    } finally {
      setGlobalLoading(false);
    }
  };

  // ############################################################

  const fetchMinorIndustry = async (e) => {
    const id = e.target.value;
    try {
      const response = await axios.get(
        `${API_BASE_URL}/common_controller/get_minor_industries_by_maji_id/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setMinorIndustries(response.data.minor_industries || []);
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  const setpeVcReferredOption = (e) => {
    const peVcReferredOption = e;
    setValue("private_equity", peVcReferredOption);
    setpeVcReferred(peVcReferredOption);
  };

  const showgroupedCompanyOther = (e) => {
    const groupedCompanyOther = e;
    console.log(groupedCompanyOther);
    if (groupedCompanyOther == 0) {
      setshowOthergroupedCompany(true);
    } else {
      setshowOthergroupedCompany(false);
    }
  };

  async function getPevcData(keyword) {
    const res = await axios.post(
      `${API_BASE_URL}/clients/companyInfoLoad`,
      {
        keywords: keyword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const options = (res.data.options || []).map((item) => ({
      value: item.value,
      label: item.label,
    }));

    const exactMatch = options.some(
      (item) => item.label.toLowerCase() === keyword.toLowerCase()
    );

    if (!exactMatch && keyword.trim() !== "") {
      options.unshift({
        value: keyword,
        label: keyword,
        custom: true,
      });
    }

    setPevcOptions(options);
  }
useEffect(() => {
  const $selects = $(".searchable-select");

  $selects.each(function () {
    const $select = $(this);

    // Destroy if already initialized
    if ($select.hasClass("select2-hidden-accessible")) {
      $select.select2("destroy");
    }

    // Initialize separately for each dropdown
    $select.select2({
      width: "100%",
      dropdownParent: $select.parent(),
      placeholder: "Select",
      allowClear: true,
    });
  });

  return () => {
    $selects.each(function () {
      const $select = $(this);

      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2("destroy");
      }
    });
  };
}, [users, countries]);

  return (
    <div className="modal fade show d-block add_client" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered modal-md add_client_modal"
        role="document"
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">
                Add Client
                <span style={{ marginLeft: "20px" }}>
                  <button type="button" className="btn btn-primary my-1 me-2">
                    Reference Id{" "}
                    <span className="badge ms-2 bg-secondary">
                      {data?.new_reference}
                    </span>
                  </button>
                </span>
              </h4>

              <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={() => {
                  clearSelect();
                  onClose?.();
                }}
              >
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ padding: "30px" }}>
              <div className="col-xl-6">
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Company *{" "}
                    {errors.companies && (
                      <span className="text-danger">
                        {errors.companies.message}
                      </span>
                    )}
                  </label>
                  <input type="hidden" {...register("reference")} />
                  {/* <select
                    name="companies"
                    className={`select2 form-select`}
                    {...register("companies", {
                      required: "required",
                    })}
                  ></select> */}
                  <Select
                    className="react-select"
                    options={companyOptions}
                    value={selectedCompany}
                    isLoading={isCompanyLoading}
                    loadingMessage={() => "Fetching options..."}
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? "No company found" : "Start typing..."
                    }
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    onChange={async (option) => {
                      clearSelect();

                      if (option.tbl === "companies") {
                        await AlreadyExitClient(option.id);
                        return;
                      } else if (option.tbl === "companyinfos") {
                        await AlreadyExitCompanyInfo(option.id);
                      }
                      setValue("companies", option.id);
                      setSelectedCompany(option);
                      lastSelectedRef.current = option;
                    }}
                    onInputChange={(value, actionMeta) => {
                      // only when typing
                      if (actionMeta.action === "input-change") {
                        // hide selected value while searching
                        if (value.trim() !== "") {
                          setSelectedCompany(null);
                        } else {
                          // restore old selected if input cleared
                          setSelectedCompany(lastSelectedRef.current);
                        }

                        // debounce api
                        if (searchTimeout.current) {
                          clearTimeout(searchTimeout.current);
                        }

                        searchTimeout.current = setTimeout(() => {
                          if (value.trim() !== "") {
                            get_companies_data(value.trim());
                          }
                        }, 500);
                      }
                    }}
                  />
                </div>

                {/* Major Industry */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Major Industry *{" "}
                    {errors.industrymaster_id && (
                      <span className="text-danger">
                        {errors.industrymaster_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("industrymaster_id", {
                      required: "required",
                    })}
                    onChange={(e) => fetchMinorIndustry(e)}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {majorIndustries.map((m) => (
                      <option key={m.id} value={Number(m.id)}>
                        {m.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Grouped Company Option */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Is this entity part of a larger corporate group? *{" "}
                    {errors.groupedCompanyOption && (
                      <span className="text-danger">
                        {errors.groupedCompanyOption.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("groupedCompanyOption", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="no">No, this is an independent company</option>
                    <option value="yes">Yes, this entity belongs to a parent company/group</option>
                  </select>
                  {groupedCompanyOption === "yes" && (
                    <>
                      <label className="form-label mt-2">
                      Parent Company / Group:
                      {errors.groupedCompany && (
                        <span className="text-danger">
                          {errors.groupedCompany.message}
                        </span>
                      )}
                    </label>
                      <select
                        {...register("groupedCompany", {
                          required: "required",
                        })}
                        onChange={(e) =>
                          showgroupedCompanyOther(e.target.value)
                        }
                        className="form-select mt-2"
                      >
                        <option value="">Select</option>
                        {companies.map((c) => (
                          <option key={c.id} value={Number(c.id)}>
                            {c.name}
                          </option>
                        ))}
                        <option value={0}>other</option>
                      </select>
                      {showOthergroupedCompany && (
                        <>
                          <span>
                            {errors.groupedCompanyOther && (
                              <span className="text-danger">
                                {errors.groupedCompanyOther.message}
                              </span>
                            )}
                          </span>
                          <input
                            type="text"
                            {...register("groupedCompanyOther", {
                              required: "required",
                            })}
                            placeholder="Enter Grouped Company Name"
                            className="form-control mt-2"
                          />
                        </>
                      )}
                    </>
                  )}
                </div>

                {/* Client Type (disabled input) */}
                <div className="row mb-3 me-3">
                  <label className="form-label">Client Type* </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("clientType", { value: "PROSPECTIVE" })}
                    disabled
                  />
                </div>
                {/* Business Developed By */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Business Developed By*{" "}
                    {errors.businessDeveloped_id && (
                      <span className="text-danger">
                        {errors.businessDeveloped_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("businessDeveloped_id", {
                      required: "required",
                    })}
                    className="form-select searchable-select"
                  >
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
                {/* BD Influence */}
                <div className="row mb-3 me-3">
                  <label className="form-label">BD Influence</label>
                  <select {...register("bdInfluence")} className="form-select searchable-select">
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-xl-6">
                {/* Website */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Website*{" "}
                    {errors.website && (
                      <span className="text-danger">
                        {errors.website.message}
                      </span>
                    )}
                  </label>
                  <input
                    type="url"
                    {...register("website", {
                      required: "required",
                    })}
                    placeholder="https://www.example.com"
                    className="form-control"
                  />
                </div>
                {/* Minor Industry */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Minor Industry*{" "}
                    {errors.industry_id && (
                      <span className="text-danger">
                        {errors.industry_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("industry_id", {
                      required: "required",
                    })}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {minorIndustries.length > 0 &&
                      minorIndustries.map((m) => (
                        <option key={m.id} value={Number(m.id)}>
                          {m.name}
                        </option>
                      ))}
                  </select>
                </div>
                {/* PE/VC Referred Option */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Does this entity have an investor relationship?*{" "}
                    {errors.private_equity && (
                      <span className="text-danger">
                        {errors.private_equity.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("private_equity", {
                      required: "required",
                      value: "no",
                    })}
                    onChange={(e) => setpeVcReferredOption(e.target.value)}
                    className="form-select"
                  >
                    <option value="no">No</option>
                    <option value="yes">Yes, this entity is a PE/VC firm or is a portfolio company of a PE/VC firm</option>
                  </select>
                  {peVcReferred === "yes" && (
                    <span className="mt-2" style={{ padding: "0" }}>
                      <label className="form-label mt-2">
                        Investor / PE / VC Firm
                         {errors.peVcReferred && (
                            <span className="text-danger">
                              {errors.peVcReferred.message}
                            </span>
                          )}
                      </label>
                      <Select
                        className="mt-2"
                        options={pevcOptions}
                        value={selectedPevc}
                        onChange={(option) => {
                          setSelectedPevc(option);
                      
                          if (option?.custom) {
                            setValue("companyinfo_id", option.label, {
                              shouldValidate: true,
                            });
                          } else {
                            setValue("companyinfo_id", option?.value || "", {
                              shouldValidate: true,
                            });
                          }
                        }}
                        onInputChange={(value, actionMeta) => {
                          if (actionMeta.action === "input-change") {
                            if (searchTimeout.current) {
                              clearTimeout(searchTimeout.current);
                            }
                      
                            searchTimeout.current = setTimeout(() => {
                              if (value.trim() !== "") {
                                getPevcData(value.trim());
                              }
                            }, 500);
                          }
                        }}
                        placeholder="Search PE/VC"
                        isClearable
                      />
                    </span>
                  )}
                </div>

                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Is this entity a Global Capability Center (GCC)?{" "}
                    <span className="fs-8">[ e.g. Is this a part of GCC]</span>
                  </label>
                  <select
                    {...register("gcc", { value: "no" })}
                    className="form-select"
                  >
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>

                {/* Origin */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Head Quarters*{" "}
                    {errors.origin && (
                      <span className="text-danger">
                        {errors.origin.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("origin", { required: "required" })}
                    className="form-select searchable-select"
                  >
                    <option value="">Select</option>
                    {countries.map((c) => (
                      <option key={c.name} value={Number(c.id)}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Client Managed By */}
                <div className="row mb-3 me-3">
                  <label className="form-label">
                    Client Managed By*{" "}
                    {errors.clientManaged_id && (
                      <span className="text-danger">
                        {errors.clientManaged_id.message}
                      </span>
                    )}
                  </label>
                  <select
                    {...register("clientManaged_id", {
                      required: "required",
                    })}
                    className="form-select searchable-select"
                  >
                    <option value="">Select</option>
                    {users.length > 0 &&
                      users.map((item, index) => (
                        <option
                          key={index}
                          value={Number(item.id)}
                        >{`${item.firstname} ${item.lastname}`}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="modal-footer" style={{ justifyContent: "center" }}>
              <button type="submit" className="btn btn-primary me-2">
                Save Client
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  clearSelect();
                  onClose?.();
                }}
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddClient;
